<template>
	<div class="car-album" id="part_car_album">
		<!-- <div class="section-title" v-sd-exp:MallItemDetailExpo="moduleTrackingInfo">
			<div>车辆实拍</div>
			<div
				@click="enterPreview"
				v-sd-exp:MallItemDetailClick="{
					...moduleTrackingInfo,
					button_name: '查看全部',
					track_sign:
						car.basic.business_type === 1
							? 'aMall.b40.d71.click.MallItemDetailClick'
							: 'aMall.b41.d69.click.MallItemDetailClick'
				}"
			>
				<div>查看全部</div>
				<nio-icon name="icon_arrows_right_2xs" />
			</div>
		</div> -->
		<div
			v-for="album in imageMap"
			class="album-item"
			v-sd-clk:VehicleDetailClick="{
				page: '二手车车辆详情页',
				label_name: car.$$track_label_name,
				tag: car.$$track_tags,
				module_name: '车辆基本信息',
				button_name: '头图',
				position_rank: 2,
				position_in_rank: 1,
				position_in_number: 1,
				track_sign: 'aMall.b4307.click.VehicleDetailClick'
			}"
		>
			<!-- <div class="item-title">{{ album.name }}</div> -->

			<div class="photo-grid" :class="album.theme">
				<template v-if="album.theme === 'triple'">
					<ratio-image
						:src="album.child.length > 0 && album.child[0].thpf_url"
						:size="670"
						@click="enterPreview(album.value, album.child[0].bannerIdx)"
					></ratio-image>

					<div>
						<ratio-image
							:src="album.child.length > 1 && album.child[1].thpf_url"
							:size="329"
							@click="enterPreview(album.value, album.child[1].bannerIdx)"
							style="margin-bottom: 3px;"
						></ratio-image>

						<ratio-image
							:src="album.child.length > 2 && album.child[2].thpf_url"
							:size="329"
							@click="enterPreview(album.value, album.child[2].bannerIdx)"
						></ratio-image>
					</div>
				</template>
				<!-- <template v-else>
					<ratio-image
						:src="album.child.length > 0 && album.child[0].thpf_url"
						:size="329"
						@click="enterPreview(album.value, album.child[0].bannerIdx)"
					></ratio-image>

					<ratio-image
						:src="album.child.length > 1 && album.child[1].thpf_url"
						:size="329"
						@click="enterPreview(album.value, album.child[1].bannerIdx)"
					></ratio-image>
				</template> -->
			</div>
		</div>
	</div>
</template>

<script>
import RatioDiv from '@/components/RatioDiv'
import link from '@/util/link'
import { cdn } from '@/util/imgCdn'
import {
	sortAlbumAppearance,
	sortAlbumInterior,
	sortBannerAppearance,
	sortBannerInterior,
	sortAlbumDouble
} from '@/views1/DetailPage/sortRules'
import sensors from '@/util/dataTrack'
import RatioImage from '@/components/RatioImage'

export default {
	name: 'CarAlbum',
	components: { RatioImage },
	props: ['car'],
	computed: {
		imageMap() {
			const list = []
			const map = [
				{
					name: '外观',
					value: 'appearance',
					theme: 'triple'
				}
			]
			map.forEach(item => {
				if (
					this.car.photo[item.value] &&
					this.car.photo[item.value].items &&
					this.car.photo[item.value].items.length
				) {
					let child = this.car.photo[item.value].items
					// 特定的排序规则
					if (item.value === 'appearance') {
						child = sortAlbumAppearance(this.car.photo.appearance.items)
					}

					// if (item.value === 'interior') {
					// 	child = sortAlbumInterior(this.car.photo.interior.items)
					// }

					// if (item.theme === 'double') {
					// 	child = sortAlbumDouble(this.car.photo[item.value].items)
					// }

					list.push({
						...item,
						child
					})
				}
			})
			return list
		},

		moduleTrackingInfo() {
			return {
				page: '二手车车辆详情页',
				position_rank: 4,
				position_in_rank: 1,
				position_in_number: 1,
				sku_code: this.car.basic.commodity_code,
				module_name: '车辆实拍'
			}
		}
	},
	methods: {
		cdn,
		enterPreview(type, childIdx) {
			sensors.track('MallItemDetailClick', {
				...this.moduleTrackingInfo,
				position_in_rank: typeof childIdx === 'number' ? childIdx + 1 : 1,
				track_sign:
					this.car.basic.business_type === 1
						? 'aMall.b40.c55.click.MallItemDetailClick'
						: 'aMall.b41.c50.click.MallItemDetailClick'
			})

			link.goToRoute('/photo-previewer', {
				type,
				child_idx: childIdx,
				sku_code: this.car.basic.commodity_code
			})

			// this.$router.push({
			// 	path: '/photo-previewer',
			// 	query: {
			// 		type,
			// 		child_idx: childIdx,
			// 		sku_code: this.car.basic.commodity_code
			// 	}
			// })
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.car-album {
	padding-top: 60px;

	.section-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 30px;

		> :first-child {
			@include subtitle_1(1.4, 400, false);
			color: $text_primary;
		}

		> :last-child {
			@include subtitle_4(1.5, 400, false);
			color: $text_primary;
			display: flex;
			align-items: center;
			white-space: nowrap;

			> :first-child {
				margin-right: 5px;
			}
		}
	}

	.album-item {
		&:not(:last-child) {
			margin-bottom: 40px;
		}
	}

	.item-title {
		display: flex;
		align-items: center;
		@include subtitle_3(1.4, bold);
		margin-bottom: 10px;
	}

	.item-subtitle {
		margin-top: 10px;
		@include subtitle_4(1.5, 400, false);
		color: $text_secondary;
		margin-bottom: 20px;
	}

	.photo-grid {
		display: flex;

		&.triple {
			> :nth-child(1) {
				margin-right: 3px;
			}

			> :nth-child(2) {
				width: calc(50% - 3px);
				margin-right: 6px;
			}

			> :nth-child(3) {
				width: calc(50% - 3px);
			}
		}
	}
}
</style>
